const JPG = 'image/jpeg';
const JPEG = 'image/jpg';

// для проверки в checkFormats
export const availableFormats = [JPG, JPEG];

// строка для перечисление через запятую доступных форматов => чтоб добавить новый нужно 'image/jpeg, image/png'
export const ACCEPT_FORMATS = 'image/jpeg';
